import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

//snack bar :)
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from 'src/app/shared/components/snackbar/snackbar.component';
import { TopProfile, TopProfileBodyObj } from '../../shared/models/operations_persona';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { DashboardCandidate, FileData, FileId } from '../../shared/models/candidate';

import { environment } from 'src/environments/environment.prod';
import { User } from '../../shared/models/user';
import { CandidateBasicDetails } from 'src/app/shared/models/schedulerAssociate';
import { EnvironmentLoaderService } from './environment-loader.service';

@Injectable({
  providedIn: 'root',
})
export class PersonaService {
  profiles: TopProfile[];
  userLoggedIn;
  profile_url: string = environment.profileUrl;
  loggedUserDetailsUrl = environment.loggedUserDetailsUrl;
  dashboardCandidateListUrl = environment.dashboardCandidateListUrl;
  validationUrl: string = environment.validationUrl;
  readonly candidateListUrl = environment.candidateListUrl;
  schedulerDashboardUrl = environment.schedulerDashboardUrl;
  readonly mongoApiUrl = environment.mongoApiUrl;
  publicationUrl = environment.publicationUrl;
  candidateUrl = environment.createCandidateUrl;
  private loggedUserDetails: BehaviorSubject<User> = new BehaviorSubject<User>(null);
  private candidateID: BehaviorSubject<any> = new BehaviorSubject<any>('');

  constructor(
    private httpclient: HttpClient,
    private snackBar: MatSnackBar,
    private envLoaderSerive: EnvironmentLoaderService,
  ) {
    this.setLoggedUserDetails({});
    this.envLoaderSerive.getEnvData().then((envjson) => {
      this.validationUrl = envjson['ValidationUrl'];
      this.profile_url = envjson['ProfileUrl'];
      this.candidateUrl = envjson['CreateCandidateUrl'];
      this.publicationUrl = envjson['PublicationUrl'];
      this.schedulerDashboardUrl = envjson['SchedulerDashboardUrl'];
    });
  }

  //set method for loggedUserDetails
  setLoggedUserDetails(user) {
    this.loggedUserDetails.next(user);
  }

  //get method for loggedUserDetails
  getLoggedUserDetails() {
    return this.loggedUserDetails.asObservable();
  }

  // base url from environment file
  // readonly BASE_URL:string = environment.BASE_API_URL;

  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
  // Data object for 'Get Candidate By Scheduler
  private topProfileBodyObj: any;
  // Setter-Getter for topProfileBodyObj
  setTopProfileBodyObj(tempTopProfileBodyObj) {
    console.log('inside setter');
    console.log(tempTopProfileBodyObj);

    this.topProfileBodyObj = tempTopProfileBodyObj;
  }
  getTopProfileBodyObj(): TopProfileBodyObj {
    return this.topProfileBodyObj;
  }

  getRequsitionDetails(reqId: number) {
    return this.httpclient.get(this.publicationUrl + 'getRequisition/' + reqId);
  }

  getSupportTeamList(reqId: number): Observable<any> {
    return this.httpclient.get<any>(this.publicationUrl + 'getSupportTeamList/' + reqId);
  }
  //snack bar method; duration in milliseconds,data is message to display, panelClass is css class from ts
  openSnackBar(message: any, panelClass: string) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: message,
      panelClass: panelClass,
      duration: 4000,
    });
  }

  getEmployersList() {
    return this.httpclient.get(this.candidateUrl + 'getAllEmploymentOrganizations');
  }

  getDashboardCandidateBatch(): Observable<DashboardCandidate[]> {
    // let tempApplicantData = this.dashboardCandidatesList;
    // let batch: DashboardCandidate[] = tempApplicantData.slice(index, index + 10);
    // return of(batch);
    // return this.httpclient.get<DashboardCandidate[]>(this.get_dashboardCandidatesLiest);

    const data = { candidateIds: [1000000141, 1000000142, 1000000155] };

    return this.httpclient.post<DashboardCandidate[]>(
      this.dashboardCandidateListUrl + 'candidate/getAllCandidates',
      data,
    );
  }

  getCandidateBatch(index: number, endIndex: number): Observable<TopProfile[]> {
    const tempApplicantData: TopProfile[] = this.profiles;
    //console.log(endIndex);
    const batch: TopProfile[] = tempApplicantData.slice(index, endIndex);
    //console.log(batch);
    return of(batch);
  }

  getProfileBatch(index: number, endIndex: number): Observable<TopProfile[]> {
    const tempProfileData: TopProfile[] = this.profiles;
    const batch: TopProfile[] = tempProfileData.slice(index, endIndex);
    return of(batch);
    //return (this.initialize());
  }
  // batchIndex = 0;
  // Fetching data from API
  fetchProfiles(): Observable<any[]> {
    return this.httpclient.post<any[]>(
      this.profile_url + 'profileService/getCandidateDetailByScheduler',
      this.getTopProfileBodyObj(),
    );
  }

  fetchProfileValidation(Id, companyHiringType): Observable<any[]> {
    let params = new HttpParams();
    params = params.append('companyHiringTypeId', companyHiringType);
    //return of(this.topProfileList);
    return this.httpclient.get<any[]>(this.validationUrl + 'dbadmin/getAssignedCandidates/' + Id, { params: params });
  }

  // Initializing-local list to display
  setTopProfiles(initialTopProfiles: TopProfile[]) {
    // console.log(initialTopProfiles);
    this.profiles = initialTopProfiles;
    // console.log(this.profiles);
  }
  getTopProfiles() {
    return this.profiles;
  }

  getCandidateTableList(requisitionId): Observable<any> {
    return this.httpclient.get<any>(this.candidateListUrl + 'candidate/getCandidateDetails/' + requisitionId);
  }

  getRecommendedTableCandidateList(requisitionId): Observable<any> {
    return this.httpclient.get<any>(this.candidateListUrl + 'candidate/getRecommendedCandidates/' + requisitionId);
  }
  getCandidateBasicDetails(applicationId: any, candidateId: any): Observable<CandidateBasicDetails> {
    return this.httpclient.get<CandidateBasicDetails>(
      this.schedulerDashboardUrl +
        'candidate/getBasicCandidateDetails?candidateId=' +
        candidateId +
        '&applicationId=' +
        applicationId,
    );
  }

  getCandidateID() {
    return this.candidateID.asObservable();
  }

  getFileId(data): Observable<FileData[]> {
    return this.httpclient.get<FileData[]>(
      this.mongoApiUrl + 'getFileId/' + data.objectId + '/' + data.objectType + '/' + data.attachmentId,
    );
  }
  getResume(id): Observable<FileId[]> {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.httpclient.get<FileId[]>(this.mongoApiUrl + "downloadFileNew", { params: params })
  }

  shareContent(payload: any, notificationType: string): Observable<any> {
    const params = new HttpParams().set('notificationType', notificationType).set('MobileRequest', 'false');
    return this.httpclient.post(this.schedulerDashboardUrl + 'hmNotification/sendMailToHM', payload, {
      params,
      responseType: 'text',
    });
  }
}
